import styles from "./MileageHeroSection.module.scss";
import Text from "@components/atoms/Text";
import { MileageHeroSideBlock } from "./MileageHeroSideSection";
import { toKebabCase } from "@utils/stringFormatters";
import ImageResponsive from "@components/atoms/ImageResponsive";
import assetLoader from "@utils/internalImageLoder";

const MileageHeroSection = ({
  title,
  carDetails,
  isSellable,
  cityName,
  onModalOpen,
  carAvailability,
  isMobile,
}: any) => {
  const filePath = `${toKebabCase(carDetails?.makeName)}/${toKebabCase(
    carDetails?.modelName
  )}`;
  
  // Construct device-specific image URLs for Speed image
  const folder = isMobile ? "small" : "large";
  const imageBaseUrl = `https://ackodrive-prod.ackoassets.com/image`;
  const speedImageUrl = `${imageBaseUrl}/${filePath}/images_cdn/${folder}/Speed.webp`;

  return (
    <div className={styles.contentContainer}>
      <div className={styles.heroImageWrapper}>
        {/* Use native img tag for LCP optimization - styles in CSS module */}
        <img
          src={speedImageUrl}
          alt={`${carDetails?.makeName} ${carDetails?.modelName} Speed`}
          className={styles.heroImage}
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
      </div>

      <div className={styles.heroSideSection}>
        <div className={styles.mileageContainerMobileImage}>
          {/* Use native img tag for mobile - styles in CSS module */}
          <img
            src={speedImageUrl}
            alt={`${carDetails?.makeName} ${carDetails?.modelName} Speed`}
            className={styles.mileageContainerImage}
            fetchPriority="high"
            loading="eager"
            decoding="async"
          />
          <div className={styles.shadowOverlay}></div>
        </div>

        <div className={styles.textSection}>
          <Text level="h1" className={styles.title}>
            {title}
          </Text>
          <Text className={styles.subtitle}>{carDetails?.mileage.range}</Text>
        </div>

        <MileageHeroSideBlock
          mileageOverview={carDetails?.mileage.mileageOverview}
          mileageVariants={carDetails?.mileage.mileageVariants.variants}
          isSellable={isSellable}
          brandName={carDetails.makeName}
          modelName={carDetails.modelName}
          cityName={cityName}
          onModalOpen={onModalOpen}
          carAvailability={carAvailability}
        />
      </div>
    </div>
  );
};

export default MileageHeroSection;
